import Vue from 'vue'
import Router from 'vue-router'

import Home from '../components/Home'
// 家电
import Jiadian from '../components/page/Jiadian'
// 模具
import Muju from '../components/page/Muju'
// 服装
import Fuzhuang from '../components/page/Fuzhuang'
// 化工
import Huagong from '../components/page/Huagong'
// 机械
import Jixie from '../components/page/Jixie'
// 建材
import Jiancai from '../components/page/Jiancai'
// 电子
import Dianzi from '../components/page/Dianzi'
// 建筑
import Jianzhu from '../components/page/Jianzhu'
// 食品
import Shipin from '../components/page/Shipin'
// 房车
import Fangche from '../components/page/Fangche'
// 农业
import Nongye from '../components/page/Nongye'
// 大健康
import Health from '../components/page/Health'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			component: Home,
			name:'home'
		},
		{
			path: '/jiadian',
			component: Jiadian
		},
		{
			path: '/muju',
			component: Muju
		},
		{
			path: '/fuzhuang',
			component: Fuzhuang
		},
		{
			path: '/huagong',
			component: Huagong
		},
		{
			path: '/jixie',
			component: Jixie
		},
		{
			path: '/jiancai',
			component: Jiancai
		},
		{
			path: '/dianzi',
			component: Dianzi
		},
		{
			path: '/jianzhu',
			component: Jianzhu
		},
		{
			path: '/shipin',
			component: Shipin
		},
		{
			path: '/fangche',
			component: Fangche
		},
		{
			path: '/nongye',
			component: Nongye
		},
		{
			path: '/health',
			component: Health
		}
	],
	scrollBehavior(to, from, savedPosition) {
		// console.log(to)
		return { x: 0, y: 0 }
	}
})



// WEBPACK FOOTER //
// ./src/pages/scheme/router/index.js